module.exports = __webpack_public_path__ + "static/media/pdf.61bb933b.svg";